/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Attack_HelpInputs */



/**
* | output |
* | --- |
* | "How quickly ducking is applied (ms) when VO starts" |
*
* @param {Audio_Description_Export_Automix_Attack_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_attack_help = /** @type {((inputs?: Audio_Description_Export_Automix_Attack_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Attack_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vitesse d'application de l'atténuation (ms) au début de la VO")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie schnell die Ducking-Funktion angewendet wird (ms), wenn VO startet")
	if (locale === "it") return /** @type {LocalizedString} */ ("Con quale rapidità viene applicato il ducking (ms) quando inizia il VO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Как быстро применяется приглушение (мс) в момент начала VO")
	if (locale === "es") return /** @type {LocalizedString} */ ("Qué tan rápido se aplica el agachamiento (ms) cuando comienza la VO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("VO开始时，闪避动作应用的速度（毫秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("VO 開始時にダッキングが適用される速さ (ms)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("VO शुरू होने पर झुकने की क्रिया कितनी जल्दी (मिलीसेकंड में) लागू होती है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Rapidez com que o mecanismo de abaixamento (ducking) é aplicado (ms) quando a VO começa.")
	return /** @type {LocalizedString} */ ("How quickly ducking is applied (ms) when VO starts")
});